import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { blue, gray, red } from '@kizen/kds/Colors';

// Consumer will likely want to choose a height, padding, and border customizations for themselves

export default styled.div`
  width: 100%;
  display: inline-flex;
  border: 1px solid ${gray['gray-500']};
  background-color: ${gray['gray-50']};
  ${({ focused }) =>
    focused &&
    css`
      border-color: ${blue['blue-700']};
    `}
  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        border-color: ${blue['blue-700']};
      }
    `}
  ${({ error }) =>
    error &&
    css`
      &&,
      &&:hover {
        // Ensure to trump disabled hover state
        border-color: ${red['red-500']};
      }
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${gray['gray-300']};
      &:hover {
        // Explicitness here helps combat default styles from elsewhere e.g. react-select
        border-color: ${gray['gray-500']};
      }
    `}
`;
